import { Vue, Prop, Component, Watch } from "@wagich/vue-facing-decorator-metadata";
import imagesLoaded from "imagesloaded";

import { render } from "./team-filter-card.html";
import type { Person, PersonListItem } from "../models/Person";
import { PersonDetail } from "./person-detail";
import { eventBus } from "../event-bus";
import { Spinner } from "~/common/spinner";

export const OpenTeamFilterCardEvent = "OpenTeamFilterCardEvent";
export interface OpenTeamFilterCardEventArgs {
	personId: string;
}

@Component({
	render,
	components: {
		PersonDetail,
		Spinner,
	}
})
export class TeamFilterCard extends Vue {
	@Prop() person: PersonListItem;
	/** The role of the active filter tab; only functions with this role are listed on the card. */
	@Prop() role: string;

	personDetail: Person | null = null;
	isActive: boolean = false;
    isLoading: boolean = false;

	get visibleFunctions() {
		return this.person.functions.filter(f => f.role == this.role);
	}

	mounted() {
		eventBus.on(OpenTeamFilterCardEvent, (e: OpenTeamFilterCardEventArgs) => {
			if (e.personId !== this.person.id) {
				this.closeDetail();
			}
		});
	}

	toggleDetail(e: Event) {
		if (this.isActive) {
			this.closeDetail();
		} else {
			this.openDetail();
			e.stopPropagation();
		}
	}

	async openDetail() {
		if (this.personDetail == null) {
			this.isLoading = true;
			let response = await fetch(`/api/persons/${this.person.id}`);
			if (response.status >= 300) {
				this.isLoading = false;
				return;
			}

			this.personDetail = await response.json();
			this.isLoading = false;
		}

		// document.addEventListener("click", this.documentClick);
		// document.querySelector(".btn-person-detail-close")?.addEventListener("click", () => this.closeDetail());

		this.showDetail();
	}

	showDetail() {
		this.isActive = true;

		let args: OpenTeamFilterCardEventArgs = { personId: this.person.id };
		eventBus.emit(OpenTeamFilterCardEvent, args);
	}

	closeDetail() {
		this.isActive = false;
		document.removeEventListener("click", this.documentClick);

		if (this.detailElement != null) {
			this.detailElement.classList.add("is-hidden");
			window.setTimeout(() => {
				if (this.detailElement != null) {
					this.detailElement.parentElement!.removeChild(this.detailElement);
					this.detailElement = null;
				}
			}, 400); // css transition takes 400ms
		}
	}

	documentClick(e: Event) {
		if (!(e.target as HTMLElement).closest(".person-detail-wrapper")) {
			this.closeDetail();
		}
	}
}
